import { Link, NavLink } from "react-router-dom";
import { useSelector } from "react-redux";
import { useEffect, useState } from "react";

import Icon from "./Icon";
import Badge from "./Badge";
import { convertRoleToPath, userRoleItems } from "../utils/enum";

const Sidebar = ({ sidebarActive, mobileMenu, mobileMenuControl }) => {
  const auth = useSelector((state) => state.auth);
  const permissions = useSelector((state) => state.permissions);
  const notifications = useSelector((state) => state.meta?.notifications);
  const tickets = useSelector((state) => state.meta?.tickets);
  const invoices = useSelector((state) => state.meta?.invoices);

  const numberOfNotifications = notifications?.length || 0;
  const numberOfTickets = tickets?.length || 0;
  const numberOfInvoices = invoices?.length || 0;

  const [menu, setMenu] = useState([]);

  const admin = [
    {
      heading: "خانه",
    },
    {
      icon: "solar:home-smile-angle-broken",
      text: "خانه",
    },
    {
      icon: "solar:bell-broken",
      text: "اعلان ها",
      link: "/notifications",
      ...(numberOfNotifications && { badge: numberOfNotifications }),
    },
    {
      icon: "solar:chat-round-call-broken",
      text: "پشتیبانی",
      link: "/tickets",
      permission: "canTickets",
      ...(numberOfTickets && { badge: numberOfTickets }),
    },
    {
      heading: "ثبت سفارش",
    },
    {
      icon: "solar:box-minimalistic-broken",
      text: "دسته بندی ها",
      link: "/category",
      permission: "canCategories",
    },
    {
      icon: "solar:box-broken",
      text: "محصولات",
      link: "/product",
      permission: "canProducts",
    },
    {
      heading: "مدیریت",
    },
    {
      icon: "solar:users-group-two-rounded-broken",
      text: "کاربران",
      link: "/users",
      permission: "canUsers",
    },
    {
      icon: "solar:reorder-broken",
      text: "سفارشات",
      link: "/orders",
      permission: "canOrders",
    },
    {
      icon: "solar:box-minimalistic-broken",
      text: "دسته بندی ها",
      link: "/categories",
      permission: "canCategories",
    },
    {
      icon: "solar:text-field-broken",
      text: "فیلد ها",
      link: "/fields",
      permission: "canFields",
    },
    {
      icon: "solar:box-broken",
      text: "محصولات",
      link: "/products",
      permission: "canProducts",
    },
    {
      icon: "solar:wad-of-money-broken",
      text: "کدهای تخفیف",
      link: "/discount-code",
      permission: "canDiscountCodes",
    },
    {
      icon: "solar:dialog-broken",
      text: "پیامک های انبوه",
      link: "/bulk-sms",
      permission: "canBulkSMSs",
    },
    {
      icon: "solar:asteroid-broken",
      text: "شهر ها",
      link: "/geo",
      permission: "canGeo",
    },
    {
      heading: "گزارش",
    },
    {
      icon: "solar:repeat-one-broken",
      text: "تمدیدها",
      link: "/renewals",
      permission: "canRenewals",
    },
    {
      icon: "solar:document-text-broken",
      text: "فاکتورها",
      link: "/invoices",
      permission: "canInvoices",
      ...(numberOfInvoices && {
        badge: numberOfInvoices,
        badgeColor: "warning",
      }),
    },
    {
      icon: "solar:card-transfer-broken",
      text: "تراکنشات",
      link: "/transactions",
      permission: "canTransactions",
    },
    {
      icon: "solar:list-broken",
      text: "رویدادنگاری",
      link: "/logs",
      permission: "canLogs",
    },
    {
      icon: "solar:hand-money-broken",
      text: "پرداخت ها",
      link: "/payments",
      permission: "canPayments",
    },
    {
      heading: "اطلاعات",
    },
    {
      icon: "solar:question-circle-broken",
      text: "سوالات متداول",
      link: "/faq",
    },
    {
      icon: "solar:shield-warning-broken",
      text: "قوانین و مقررات",
      link: "/terms",
    },
    {
      icon: "solar:info-square-broken",
      text: "درباره ما",
      link: "/about-us",
    },
    {
      heading: "تنظیمات",
    },
    {
      icon: "solar:settings-broken",
      text: "تنظیمات اصلی",
      link: "/setting",
      permission: "canSettings",
    },
    {
      icon: "solar:question-square-broken",
      text: "سوالات متداول",
      link: "/faqs",
      permission: "canFAQs",
    },
  ];
  const staff = [
    {
      heading: "خانه",
    },
    {
      icon: "solar:home-smile-angle-broken",
      text: "خانه",
    },
    {
      icon: "solar:bell-broken",
      text: "اعلان ها",
      link: "/notifications",
      ...(numberOfNotifications && { badge: numberOfNotifications }),
    },
    {
      icon: "solar:chat-round-call-broken",
      text: "پشتیبانی",
      link: "/tickets",
      ...(numberOfTickets && { badge: numberOfTickets }),
    },
    {
      heading: "ثبت سفارش",
    },
    {
      icon: "solar:box-minimalistic-broken",
      text: "دسته بندی ها",
      link: "/category",
    },
    {
      icon: "solar:box-broken",
      text: "محصولات",
      link: "/product",
    },
    {
      heading: "مدیریت",
    },
    {
      icon: "solar:reorder-broken",
      text: "سفارشات",
      link: "/orders",
    },
    {
      heading: "گزارش",
    },
    {
      icon: "solar:repeat-one-broken",
      text: "تمدیدها",
      link: "/renewals",
    },
    {
      icon: "solar:document-text-broken",
      text: "فاکتورها",
      link: "/invoices",
      ...(numberOfInvoices && {
        badge: numberOfInvoices,
        badgeColor: "warning",
      }),
    },
    {
      icon: "solar:card-transfer-broken",
      text: "تراکنشات",
      link: "/transactions",
    },
    {
      icon: "solar:hand-money-broken",
      text: "پرداخت ها",
      link: "/payments",
    },
    {
      heading: "اطلاعات",
    },
    {
      icon: "solar:question-circle-broken",
      text: "سوالات متداول",
      link: "/faq",
    },
    {
      icon: "solar:shield-warning-broken",
      text: "قوانین و مقررات",
      link: "/terms",
    },
    {
      icon: "solar:info-square-broken",
      text: "درباره ما",
      link: "/about-us",
    },
  ];
  const customer = [
    {
      heading: "خانه",
    },
    {
      icon: "solar:home-smile-angle-broken",
      text: "خانه",
    },
    {
      icon: "solar:bell-broken",
      text: "اعلان ها",
      link: "/notifications",
      ...(numberOfNotifications && { badge: numberOfNotifications }),
    },
    {
      icon: "solar:chat-round-call-broken",
      text: "پشتیبانی",
      link: "/tickets",
      ...(numberOfTickets && { badge: numberOfTickets }),
    },
    {
      heading: "ثبت سفارش",
    },
    {
      icon: "solar:box-minimalistic-broken",
      text: "دسته بندی ها",
      link: "/category",
    },
    {
      icon: "solar:box-broken",
      text: "محصولات",
      link: "/product",
    },
    {
      heading: "مدیریت",
    },
    {
      icon: "solar:reorder-broken",
      text: "سفارشات",
      link: "/orders",
    },
    {
      heading: "گزارش",
    },
    {
      icon: "solar:repeat-one-broken",
      text: "تمدیدها",
      link: "/renewals",
    },
    {
      icon: "solar:document-text-broken",
      text: "فاکتورها",
      link: "/invoices",
      ...(numberOfInvoices && {
        badge: numberOfInvoices,
        badgeColor: "warning",
      }),
    },
    {
      icon: "solar:card-transfer-broken",
      text: "تراکنشات",
      link: "/transactions",
    },
    {
      icon: "solar:hand-money-broken",
      text: "پرداخت ها",
      link: "/payments",
    },
    {
      heading: "اطلاعات",
    },
    {
      icon: "solar:question-circle-broken",
      text: "سوالات متداول",
      link: "/faq",
    },
    {
      icon: "solar:shield-warning-broken",
      text: "قوانین و مقررات",
      link: "/terms",
    },
    {
      icon: "solar:info-square-broken",
      text: "درباره ما",
      link: "/about-us",
    },
  ];

  const filterMenuItems = (menuItems) => {
    return menuItems
      .map((menu) => {
        if (menu.permission && !permissions[menu.permission]) return null;

        if (menu.subMenu) {
          const filteredSubMenu = filterMenuItems(menu.subMenu);
          menu.subMenu = filteredSubMenu.filter((item) => item !== null);
          return menu.subMenu.length > 0 ? menu : null;
        }

        return menu;
      })
      .filter((menu) => menu !== null);
  };

  useEffect(() => {
    const items = {
      [userRoleItems[0]]: admin,
      [userRoleItems[1]]: staff,
      [userRoleItems[2]]: customer,
    };
    // setMenu(
    //   items[auth?.role || userRoleItems[2]].filter((_i) => !isBoolean(_i))
    // );
    setMenu(filterMenuItems(items[auth?.role || userRoleItems[2]]));
  }, [auth, permissions]);

  const renderMenu = (item) => {
    if (!!item.heading)
      return (
        <li key={item.heading} className="sidebar-menu-group-title">
          {item.heading}
        </li>
      );
    const linkUrl = `/${convertRoleToPath(auth.role)}${item.link || ""}`;

    if (!!item.text)
      return (
        <li key={item.link + item.text}>
          <NavLink
            to={linkUrl}
            end
            className={(navData) => (navData.isActive ? "active-page" : "")}
          >
            <Icon icon={item.icon} className="menu-icon" />
            <span className="w-75">{item.text}</span>
            {item.badge && (
              <Badge color={item.badgeColor || "info"} className="me-auto">
                {item.badge}
              </Badge>
            )}
          </NavLink>
        </li>
      );
  };

  return (
    <aside
      className={
        sidebarActive
          ? "sidebar active "
          : mobileMenu
          ? "sidebar sidebar-open"
          : "sidebar"
      }
    >
      <button
        onClick={mobileMenuControl}
        type="button"
        className="sidebar-close-btn"
      >
        <Icon icon="solar:close-circle-broken" className="text-xl" />
      </button>
      <div>
        <Link to="/" className="sidebar-logo">
          <img
            src="/assets/images/logo.svg"
            alt="site logo"
            className="light-logo"
          />
          <img
            src="/assets/images/logo-light.svg"
            alt="site logo"
            className="dark-logo"
          />
          <img
            src="/assets/images/logo-icon.svg"
            alt="site logo"
            className="logo-icon"
          />
        </Link>
      </div>
      <div className="sidebar-menu-area">
        <ul className="sidebar-menu" id="sidebar-menu">
          {menu.map(renderMenu)}
        </ul>
      </div>
    </aside>
  );
};

export default Sidebar;
